var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "table-height",
          attrs: {
            border: "",
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            height: _vm.tableHeightRow.height,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "80",
              fixed: "left",
            },
          }),
          _vm._l(_vm.columnList, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                label: item.label,
                "min-width": item.width,
                align: item.align,
                prop: item.prop,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "status"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 0
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("GlobalSetObj.disable"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.status === 1
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "primary" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("GlobalSetObj.enable"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : item.prop === "smallCalculateBase"
                          ? _c("div", [
                              scope.row.smallCalculationMethod === 0
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                              scope.row.smallCalculationMethod === 1
                                ? _c("span", [_vm._v("/")])
                                : _vm._e(),
                              _vm._v(" " + _vm._s(scope.row[item.prop]) + " "),
                            ])
                          : item.prop === "largeCalculateBase"
                          ? _c("div", [
                              scope.row.largeCalculationMethod === 0
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                              scope.row.largeCalculationMethod === 1
                                ? _c("span", [_vm._v("/")])
                                : _vm._e(),
                              _vm._v(" " + _vm._s(scope.row[item.prop]) + " "),
                            ])
                          : item.prop === "currentVersion"
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#00a551",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewHistory(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c("u", [
                                    _vm._v(_vm._s(scope.row[item.prop])),
                                  ]),
                                ]
                              ),
                            ])
                          : item.prop === "createUser" ||
                            item.prop === "updateUser"
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getUserName(
                                      scope.row[item.prop],
                                      _vm.userNameStr
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(" " + _vm._s(scope.row[item.prop]) + " "),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.operate"),
              width: "260",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "but:finance:basicData:channelVolume:view",
                            expression:
                              "'but:finance:basicData:channelVolume:view'",
                            arg: "remove",
                          },
                        ],
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row, 1)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.View")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value:
                              "but:finance:basicData:channelVolume:iteration",
                            expression:
                              "'but:finance:basicData:channelVolume:iteration'",
                            arg: "remove",
                          },
                        ],
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row, 2)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("ChannelManage.iteration")) + " "
                        ),
                      ]
                    ),
                    scope.row.status === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "but:finance:basicData:channelVolume:edit",
                                expression:
                                  "'but:finance:basicData:channelVolume:edit'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("GlobalSetObj.enable")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "but:finance:basicData:channelVolume:edit",
                                expression:
                                  "'but:finance:basicData:channelVolume:edit'",
                                arg: "remove",
                              },
                            ],
                            attrs: { type: "warning", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("GlobalSetObj.disable")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }